import Vue from "vue";

Vue.component("country-enquiry-point", {
	props: [
		"domainId",
		"countryId",
		"language",
		"contactType",
		"isAdmin"
	],
	data() {
		return {
			dataItem: [],
			loadingText: window.labels.loading,
			deleteText: window.labels.delete,
			editText: window.labels.edit,
			additionalInformationLabel: window.labels.additionalInformation,
			sameAsNNAText: window.labels.sameAsNNA,
			loading: false
		};
	},
	methods: {
		getCountryEnquiryPoint: function () {
			this.loading = true;
			this.$services.contacts.getCountryEnquiryPointList({
				countryId: this.countryId,
				domainId: this.domainId,
				contactType: this.contactType,
				language: this.language
			})
				.then((data) => {
					this.dataItem = data;
					this.loading = false;
				});
		},
		editItem: function (id) {
			this.$emit('edit', id)
		},
		deleteItem: function (id) {
			this.$emit('delete-item', id)
		}
	},
	mounted: function () {
		this.getCountryEnquiryPoint();
	},
	template: `
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else>
			<div :key="item.value" v-for="item in dataItem.items">
				<div v-if="item.canEdit" class="enquiry-point-info">
					<b-dropdown aria-role="list">
						<template #trigger="{ active }">
							<b-button label=""
									  type="is-light is-small"
									  :icon-left="'ellipsis-h'"/>
						</template>
						<b-dropdown-item aria-role="listitem" @click="editItem(item.id)">
							<i class="fas fa-pencil-alt has-text-primary"></i> {{ editText }}
						</b-dropdown-item>
						<b-dropdown-item v-if="isAdmin" aria-role="listitem" @click="deleteItem(item.id)">
							<i class="fas fa-trash-alt has-text-danger"></i> {{ deleteText }}
						</b-dropdown-item>
					</b-dropdown>									
				</div>
				<div v-html="item.personAddress"></div>
				<div v-html="item.contactInformation"></div>
				<div v-if="item.additionalInformation" class="mt-1">
					<strong>{{ additionalInformationLabel }}:</strong>
					<span style="white-space: pre-wrap">{{ item.additionalInformation }}</span>
				</div>
				<div class="mb-3"></div>
			</div>
		</div>
	`
});